import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {IDisplayColumn} from '@shared/library/crud-library/crud-list/crud-list.component';
import {CrudCompaniesService} from '@shared/services/crud-companies.service';

@Component({
  selector: 'app-companies-users',
  templateUrl: './companies-users.component.html',
  styleUrls: ['./companies-users.component.scss']
})
export class CompaniesUsersComponent implements OnInit {

  observabledata?: Observable<any>;
  usertools: any[];
  displayedcolumns: IDisplayColumn[] = [];
  entityadminuri: string;

  companyId: string;
  sectionTitle: string;

  constructor(
    private router: Router,
    protected route: ActivatedRoute,
    private companyService: CrudCompaniesService,
  ) {

  }

  ngOnInit(): void {
    this.companyId = this.route.snapshot.paramMap.get('id');

    this.entityadminuri = `/admin/companies/${this.companyId}/users`;

    this.companyService.getEntity(this.companyId).subscribe(({results}) => {
      console.log(results);
      this.sectionTitle = results.label + ' user tools';
    });

    this.observabledata = this.companyService.getUserTools(this.companyId);

    this.displayedcolumns = [
      {columnName: 'id', label: 'ID', isKeyColumn: true},
      {columnName: 'username', label: 'User'},
      {columnName: 'toolname', label: 'Tool'}
    ] as IDisplayColumn[];
  }

  getObservableData(): Observable<any> | undefined {
    return this.observabledata;
  }

  getPostTreatmentCallback(): any {
    return (data: any): any => {
      this.usertools = data.results;
      return data.results;
    };
  }

  deleteEntityHandler(): any {
    return (idvalue) => {
      return this.companyService.removeUserTool(idvalue);
    };
  }

  getListEditPathCallback() {
    return (idvalue) => {
      const rel = this.usertools.filter((ut) => ut.id === idvalue)[0];
      return '/admin/users/' + rel.userid + '/usertoolconfigs/' + rel.toolid + '/edit';
    };
  }

  deletePostTreatmentHandler() {
    return (idvalue, entityroot) => {
      // Refresh same page
      this.router.navigateByUrl('/', {skipLocationChange: true})
        .then(() => this.router.navigate([entityroot]));
    };
  }

}
